import React, { useState } from "react";

import Lottie from "react-lottie";
import { colors } from "nxtconstants";
import styled from "styled-components";

function FeatureBlock({
  image,
  lottieAnimation,
  heading,
  numberHeading,
  subtitle,
  description,
  reverse,
  rotateOnHover,
  customMargin
}) {
  const [isPaused, setIsPaused] = useState(false);

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <BlockContainer reverse={reverse} customMargin={customMargin}>
      {lottieAnimation ? (
        <LottieContainer
          className="feature-lottie"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <Lottie
            options={lottieOptions}
            isPaused={isPaused}
            isClickToPauseDisabled={true}
            ariaRole="img"
            ariaLabel={heading}
            height="100%"
            width="100%"
            style={{width: "100%", height: "100%"}}
          />
        </LottieContainer>
      ) : (
        <BlockImage
          src={image}
          alt={heading}
          width={560}
          height={560}
          sizes="(max-width: 768px) 80vw, 50rem"
          loading="lazy"
          decoding="async"
          onMouseEnter={rotateOnHover ? () => setIsPaused(true) : undefined}
          onMouseLeave={rotateOnHover ? () => setIsPaused(false) : undefined}
        />
      )}
      <BlockTextContainer>
        <BlockSubtitle>{subtitle}</BlockSubtitle>
        {numberHeading && (
          <BlockNumberHeading>{numberHeading}</BlockNumberHeading>
        )}
        <BlockHeading>{heading}</BlockHeading>
        <BlockDescription>{description}</BlockDescription>
      </BlockTextContainer>
    </BlockContainer>
  );
}

const BlockContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  gap: 10rem;
  width: 85%;
  max-width: 125rem; 
  margin: 0 auto;
  margin-bottom:5rem;
  

  @media (max-width: 786px) {
    margin-top: 0rem;
    flex-direction: column;
    gap: 2.7rem;
    text-align: center;
    width: 85%;
  }
`;

const BlockNumberHeading = styled.h2`
  font-family: "DM Serif Display";
  font-size: 5rem;
  font-weight: 400;
  margin-bottom: 0;
  color: #1C1C1C;

  @media(max-width:768px){
    display: none;
  }
`;

const BlockImage = styled.img`
  width: 50rem;
  height: auto;
  object-fit: contain;
  transition: transform 5s;

  @media (max-width:768px){
    width: 80%;
    object-fit: contain;
  }
`;

const BlockHeading = styled.h2`
  font-family: "DM Serif Display";
  line-height: 1.2;
  font-size: 5rem;
  font-weight: 400;
  margin-bottom: 4rem;
  white-space: pre-line;

  @media(max-width:768px){
    font-size: 2.7rem;
    line-height: 1.2;
    margin-bottom: 1.4rem;
    text-align: left;
  }
`;

const BlockSubtitle = styled.p`
  font-family: 'Lato';
  font-size: 3rem;
  font-weight: 400;
  margin-bottom: 3rem;
  color: #222;

  @media(max-width:768px){
    font-size: 1.6rem;
    font-weight: 600;
    text-align: left;
    margin-bottom: 1.4rem;
  }
`;

const BlockDescription = styled.p`
  font-size: 2rem;
  font-family: 'Lato';
  font-weight:400;
  line-height: 1.6;
  color: ${colors.textGray};

  @media(max-width: 768px){
    font-size: 1.4rem;
    font-family: 'Lato';
    font-weight: 400;
    text-align: left;
    line-height: 20px;
    color: #7E7E7E;
  }
`;

const LottieContainer = styled.div`
  width: 50rem;
  height: 50rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  > div {
    width: 100% !important;
    height: 100% !important;
  }

  svg {
    width: 100% !important;
    height: 100% !important;
  }

  @media (max-width:768px){
    width: 80%;
    height: auto;
    aspect-ratio: 1;
    max-width: 80%;
  }
`;


const BlockTextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export default FeatureBlock;